export const releases = [
  {
    version: "2.3.2",
    date: "September 13, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.3.2",
    content: [
      {
        title: "docs changes",
        data: [
          "Input, Breadcrumb, Collapse, Dialog, Form, Gallery, Image, List, Menu components with code & UI changes",
          "Added new examples for Select component"
        ],
      },
    ],
  },
  {
    version: "2.3.1",
    date: "September 6, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.3.1",
    content: [
      {
        title: "docs changes",
        data: [
          "Input component - Code & UI changes",
          "Input Number component - Code & UI changes",
          "Input Phone component - Code & UI changes",
          "Input Search component - Code & UI changes",
          "Chip component - Code & UI changes",
          "Radio Button component - Code & UI changes",
          "Switch component - Code & UI changes",
          "Tabs component - Code & UI changes",
          "Pagination component - Code & UI changes",
          "Navbar component - Code & UI changes",
          "Card component - Code & UI changes",
          "Typography component - Code & UI changes",
        ],
      },
    ],
  },
  {
    version: "2.3.0",
    date: "August 30, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.3.0",
    content: [
      {
        title: "patch changes",
        data: [
          "Accordion component - Code & UI changes",
          "Alert component - Code & UI changes",
          "Badge component - Code & UI changes",
          "Button component - Code & UI changes",
          "Button Group component - Code & UI changes",
          "Icon Button component - Code & UI changes",
          "Badge component - Code & UI changes",
        ],
      },
    ],
  },
  {
    version: "2.2.5",
    date: "August 20, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.2.5",
    content: [
      {
        title: "docs changes",
        data: [
          "New category Input Search",
          "New components added to Input Search category",
          "New components added to Input Phone category",
          "New components added to Table category",
        ],
      },
    ],
  },
  {
    version: "2.2.4",
    date: "August 19, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.2.4",
    content: [
      {
        title: "patch changes",
        data: ["Reduce the bundle size"],
      },
    ],
  },
  {
    version: "2.2.3",
    date: "August 16, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.2.3",
    content: [
      {
        title: "minor changes",
        data: ["Add new colors: slate, neutral"],
      },
      {
        title: "docs changes",
        data: [
          "New components added to Input category",
          "New components added to Input Number category",
          "New components added to Input Phone category",
          "New components added to Table category",
        ],
      },
    ],
  },
  {
    version: "2.2.2",
    date: "January 01, 2024",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.2.2",
    content: [
      {
        title: "minor changes",
        data: [
          "Add new component collapse.",
          "Fix the collapse script issue for accordion component.",
        ],
      },
      {
        title: "docs changes",
        data: ["New components: Collapse"],
      },
    ],
  },
  {
    version: "2.1.2",
    date: "December 20, 2023",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.1.2",
    content: [
      {
        title: "docs changes",
        data: [
          "New components: Skeleton, Gallery, Mega Menu",
          "New plugins integration: Tiptap Rich Text Editor, Copy to Clipboard",
          "New framework integration guides.",
        ],
      },
    ],
  },
  {
    version: "2.1.1",
    date: "December 13, 2023",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.1.1",
    content: [
      {
        title: "docs changes",
        data: [
          "Fixed broken links.",
          "Fixed typos.",
          "Updated icon button examples.",
        ],
      },
    ],
  },
  {
    version: "2.1.0",
    date: "Dec 01, 2023",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.1.0",
    content: [
      {
        title: "Minor Updates",
        data: ["Update components design", "Add new components"],
      },
      {
        title: "Docs Updates",
        data: [
          "Add plugins integration guide.",
          "Add frameworks integration guide.",
        ],
      },
    ],
  },
  {
    version: "2.0.0",
    date: "Jan 23, 2023",
    name: "@material-tailwind/html",
    description: "Material Tailwind v2.0.0",
    content: [
      {
        title: "Major Updates",
        data: [
          "Migration from custom classes to pure tailwind css classes.",
          "New scripts for interactive components using the data attributes.",
        ],
      },
      {
        title: "Docs Updates",
        data: [
          "Update the entire documentation for the html components.",
          "Uses pure tailwind css class for html component rather than custom classes.",
          "New demo/code preview added for documentation of components.",
          "Add more info and description for each page and how to use the components.",
        ],
      },
    ],
  },
  {
    version: "1.2.4",
    date: "Jan 01, 2023",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.2.4",
    content: [
      {
        title: "Patch Updates",
        data: [
          "Fix css transition typo mistake.",
          "Fix css transition typo mistake.",
        ],
      },
    ],
  },
  {
    version: "1.2.2",
    date: "Sep 30, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.2.2",
    content: [
      {
        title: "Patch Updates",
        data: ["make the components themable."],
      },
    ],
  },
  {
    version: "1.2.1",
    date: "Aug 01, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.2.1",
    content: [
      {
        title: "Patch Updates",
        data: ["Update the readme file"],
      },
    ],
  },
  {
    version: "1.2.0",
    date: "Jul 29, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.2.0",
    content: [
      {
        title: "Minor Updates",
        data: ["Rename blue-grey to blue-gray", "Rename grey to gray"],
      },
    ],
  },
  {
    version: "1.1.6",
    date: "Jun 28, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.6",
    content: [
      {
        title: "Patch Updates",
        data: [
          "Rename minified stylesheet from tailwind.css to material-tailwind.css.",
        ],
      },
    ],
  },
  {
    version: "1.1.5",
    date: "Jun 28, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.5",
    content: [
      {
        title: "Patch Updates",
        data: [
          "Add minified stylesheet with all classes and styles for CDN usage.",
        ],
      },
    ],
  },
  {
    version: "1.1.4",
    date: "Jun 28, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.4",
    content: [
      {
        title: "Patch Updates",
        data: [
          "Add minified stylesheet with all classes and styles for CDN usage",
        ],
      },
    ],
  },
  {
    version: "1.1.3",
    date: "Jun 28, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.3",
    content: [
      {
        title: "Patch Updates",
        data: [
          "Fix the components radio button issue",
          "Update radio button input style",
        ],
      },
      {
        title: "Docs Updates",
        data: [
          "Update radio button page.",
          "Update switch/toggle page",
          "Update the screens page",
        ],
      },
      {
        title: "Others",
        data: ["Add new script for compiling utils directory"],
      },
    ],
  },
  {
    version: "1.1.2",
    date: "Jun 24, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.2",
    content: [
      {
        title: "Docs Updates",
        data: [
          "Update the installation guide.",
          "Add theming and customization guide",
          "Update overall components documentation pages and add the required-script section for necessary component.",
        ],
      },
    ],
  },
  {
    version: "1.1.1",
    date: "Jun 24, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.1",
    content: [
      {
        title: "Patch Updates",
        data: ["Fix nested menu component issue."],
      },
    ],
  },
  {
    version: "1.1.0",
    date: "May 31, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.1.0",
    content: [
      {
        title: "Minor Updates",
        data: [
          "Menu",
          "Dialog",
          "Navbar",
          "Accordion",
          "Breadcrumbs",
          "Card",
          "Pagination",
          "Popover",
          "Tabs",
          "Select",
          "Tooltip",
        ],
      },
    ],
  },
  {
    version: "1.0.3",
    date: "May 11, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.0.3",
    content: [
      {
        title: "Patch Updates",
        data: ["Update Readme file"],
      },
    ],
  },
  {
    version: "1.0.2",
    date: "May 11, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.0.2",
    content: [
      {
        title: "Patch Updates",
        data: ["Update Readme file"],
      },
    ],
  },
  {
    version: "1.0.1",
    date: "May 11, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.0.1",
    content: [
      {
        title: "Patch Updates",
        data: ["Update Readme file"],
      },
    ],
  },
  {
    version: "1.0.0",
    date: "May 11, 2022",
    name: "@material-tailwind/html",
    description: "Material Tailwind v1.0.0",
    content: [
      {
        title: "Original Release",
        data: [
          "Started project from Tailwind CSS and Material Design 2",
          "Added design from Material Design 2 using Tailwind CSS",
        ],
      },
    ],
  },
];

export default releases;
